export default __webpack_public_path__ + "static/media/image@3x.ff39f7ba.png";